<template>
  <a-modal :visible="visible" title="关联机构" width="900px" :footer="null" @cancel="handleCancel">
    <div>
      <a-form :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
        <a-row>
          <a-col :span="8">
            <a-form-item label="机构名称">
              <a-input placeholder="请输入机构名称" v-model="searchForm.organizationName" allowClear/>
            </a-form-item>
          </a-col>
          <a-col :span="16">
            <a-form-item>
              <a-button type="primary" style="margin-left: 16px; margin-right: 8px" @click="getPageList(1)">查询</a-button>
              <a-button @click=";(searchForm = {}), getPageList(1)">重置</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <a-row style="margin-bottom: 10px">
        <span>【{{ resource.name }}】被以下<span  style="color: red">{{ resource.usageCount || 0 }}</span>个机构使用</span>
      </a-row>
      <a-table :columns="orgModalColUmn" :pagination="gradeTableRelevant.tablePagination" row-key="id" :loading="gradeTableRelevant.tableLoading" :data-source="gradeTableRelevant.tableDataSource">
        <div slot="action" slot-scope="text" @click="goOrgDetail(text)">
          <a> 查看</a>
        </div>
        <div slot="enabled" slot-scope="text" @click="goOrgDetail(text)">
          <span v-if="text.enabled">启用</span>
          <span v-else>禁用</span>
        </div>

        <div slot="orgType" slot-scope="record">
          <span v-if="record.orgType == 0">官方自营</span>
          <span v-if="record.orgType == 1">学校</span>
          <span v-if="record.orgType == 2">机构</span>
          <span v-if="record.orgType == 3">第三方平台</span>
          <span v-if="record.orgType == 6">脑智家游</span>
        </div>
      </a-table>
    </div>
  </a-modal>
</template>
<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
export default {
  name: 'relevanceOrg',
  props: {
    visible: Boolean,
    resource: Object,
    seriesInfo: Object,
  },
  model: {
    prop: 'visible',
    event: 'change'
  },
  data() {
    return {
      gradeTableRelevant: tableRelevant.call(this),
      searchForm: {
        organizationName: undefined
      },
      orgModalColUmn: [
        {
          title: '机构名称',
          dataIndex: 'name',
        },
        {
          title: '机构类型',
          scopedSlots: { customRender: 'orgType' },
        },
        {
          title: '机构状态',
          scopedSlots: { customRender: 'enabled' },
        },
        {
          title: '关联时间',
          dataIndex: 'createTime',
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  watch: {
    visible(bool) {
      bool && this.getPageList(1);
    },
  },
  methods: {
    getPageList(pageIndex) {
      for (let searchFormKey in this.searchForm) {
        if (this.searchForm[searchFormKey] === ""){
          this.searchForm[searchFormKey] = undefined;
        }
      }
      const params = {
        pageIndex: pageIndex || this.gradeTableRelevant.tablePagination.current,
        pageSize: this.gradeTableRelevant.tablePagination.pageSize,
        ...this.searchForm,
        // resourcePackageId: this.seriesInfo.id,
        id: this.resource.id,
      }
      this.gradeTableRelevant.tableLoading = true
      this.$http.CourseService.organizations(this.resource.id, params).then(({data}) => {
        this.gradeTableRelevant.tableDataSource = data.items
        this.gradeTableRelevant.tablePagination.total = data.totalCount
        this.gradeTableRelevant.tablePagination.current = data.pageIndex
      }).finally(() => {
        this.gradeTableRelevant.tableLoading = false
      })
    },
    goOrgDetail(record) {
      this.$emit("change", false);
      const query = {
        id: record.organizationId,
        // params: JSON.stringify({ ...this.resource, resourcePackageId: this.resource.id }),
        oId: record.organizationId,
        tabActive: 3,
      }
      this.$router.push({ path: '/projectImpl/pMechanism/orgDetails/page', query })
    },
    handleCancel() {
      for (let searchFormKey in this.searchForm) {
        this.searchForm[searchFormKey] = undefined;
      }
      this.$emit("change", false);
    },
  },
}
</script>
